export const LOCAL_STORAGE_KEYS = {
  USER_DATA: 'userData',
  CURRENT_SELECTED_WALLET: 'currentSelectedWallet',
  UNFINISHED_COMMIT_REVEAL_ACTIONS: 'UnfinishedCommitRevealActions',
  ETHEREUM_CHAINS: 'ethereumChains',
  CURRENT_ETHEREUM_CHAIN: 'currentEthereumChain',
  ALLOWED_APPLICATIONS: 'allowedApplications',
  IS_L2_DISPLAY: 'isL2Display',
  KASPA_L1_NETWORK: 'kaspaL1Network',
  REFERRAL_CODE: 'referralCode',
};

export const KASPA_NETWORKS = {
  MAINNET: 'mainnet',
  TESTNET10: 'testnet-10',
  TESTNET12: 'testnet-12',
};

export const DEFAULT_DERIVED_PATH = "m/44'/111111'/0'/0/0";
export const WALLET_APP_ID = 'WALLET_APP';
export const KAS_NATIVE_FEE_RESERVE = 5;
